// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import EnterOutlinedSvg from "@ant-design/icons-svg/lib/asn/EnterOutlined";
import AntdIcon from "../components/AntdIcon";
const EnterOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: EnterOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    EnterOutlined.displayName = "EnterOutlined";
}
export default /*#__PURE__*/ React.forwardRef(EnterOutlined);
